import { FC } from 'react';
import { withStyles, Card } from 'vopay';
import styles from './ExportMenu.module.scss';
import useFileDownload from '@/hooks/useFiledDownload';
import { UtilButton } from 'UI';

import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { useTranslation } from 'react-i18next';

const cn = withStyles(styles);

type ExportMenuProps = {};

const exportTypes = ['PDF', 'CSV'] as const;

const ExportMenu: FC<ExportMenuProps> = ({}) => {
  const { downloadPdfTable, downloadCsvFile } = useFileDownload();
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  const types: Record<(typeof exportTypes)[number], () => void> = {
    PDF: () => downloadPdfTable('paas-transaction-history', 'transactions'),
    CSV: () => downloadCsvFile('paas-transaction-history', 'transactions'),
  };

  const exportTable = (type: (typeof exportTypes)[number]) => {
    const fn = types[type];

    if (fn) fn();
  };

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <UtilButton iconRight="file_export">{tGlobal('Buttons.export')}</UtilButton>
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content sideOffset={8} className={cn('contentContainer')}>
          <Card
            style={{
              padding: '8px',
              borderRadius: 12,
              borderColor: '#2d2d2d4d',
            }}
            className={cn('menu')}
          >
            {exportTypes.map((t) => (
              <DropdownMenu.Item key={t} className={cn('item')} onClick={() => exportTable(t)}>
                {t}
              </DropdownMenu.Item>
            ))}
          </Card>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
};

export default ExportMenu;
